// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__19GVN","content":"styles_content__1FTFE","checkbox":"styles_checkbox__8JTKI","checkboxLabel":"styles_checkboxLabel__PrLkW"};